<template>
  <div
    :class="className"
    @click="go()">
    <i :class="icon"/>
  </div>
</template>

<script>
export default {
  name: 'IconLink',
  components: {},
  props: {
    className: {
      type: Object,
      default: Object,
    },
    to: {
      type: String,
      default: '',
    },
    goBack: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
  },
  methods: {
    go() {
      if (this.goBack) {
        this.$router.go(-1);
      } else if (this.to) {
        return this.$router.push(this.to);
      }
      return this.$emit('click');
    },
  },
};
</script>

<style scoped lang="scss">
div {
  i {
    cursor: pointer;
  }
}

.backButton {
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 30px;
}

.menuButton {
  position: absolute;
  right: 10px;
  top: 10px;
  font-size: 30px;
}

.size-30 {
  font-size: 30px;
}

.activeIcon {
  color: $secondary;
}
</style>
